import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const SESSION_KEY = 'wynecellar.session'

const getDefaultState = () => ({
    inSession: false,

    current_page: 'Login',
    previous_page: '',
    context: '',

    database: {},

    user: {},
    user_id: 0,
    profile_picture: '',
    language: 'en',

    cellar: {},
    cellar_id: 0,
    cellar_loaded: false,

    niches: [],
    niches_loaded: false,

    niche: {},
    niche_id: 0,

    bottle: {},
    bottle_id: 0,

    wine: {},
    wine_id: 0,

    c_wine: {},
    c_wine_id: 0,

    entry: {},
    entry_id: 0,

    wishlist: {},
    wishlist_id: 0,

    search_state: {},
})

export const store = new Vuex.Store({
    state: getDefaultState(),

    getters:{
        inSession: state => {
            return state.inSession
        },

        currentDatabase: state => {
            return state.database
        },

        currentUser: state => {
            return state.user
        },

        currentUserID: state => {
            return state.user_id
        },

        profilePicture: state => {
            return state.profile_picture
        },

        currentLanguage: state => {
            return state.language
        },

        currentCellar: state => {
            return state.cellar
        },

        currentCellarID: state => {
            return state.cellar_id
        },

        currentCellarLoaded: state => {
            return state.cellar_loaded
        },

        currentNiches: state => {
            return state.niches
        },

        currentNichesLoaded: state => {
            return state.niches_loaded
        },

        currentNiche: state => {
            return state.niche
        },

        currentNicheID: state => {
            return state.niche_id
        },

        currentEntry: state => {
            return state.entry
        },

        currentEntryID: state => {
            return state.entry_id
        },

        currentPage: state => {
            return state.current_page
        },

        previousPage: state => {
            return state.previous_page
        },

        context: state => {
            return state.context
        },

        currentSearchState: state => {
            return state.search_state
        },

        getBottle: state => {
            return state.bottle
        },

        getBottleID: state => {
            return state.bottle_id
        },

        getWine: state => {
            return state.wine
        },

        getWineID: state => {
            return state.wine_id
        },

        getCWine: state => {
            return state.c_wine
        },

        getCWineID: state => {
            return state.c_wine_id
        },

        getWishlist: state => {
            return state.wishlist
        },

        getWishlistID: state => {
            return state.wishlist_id
        },
    },

    mutations:{
        resetStore: state => {
            Object.assign(state, getDefaultState())
        },

        login:state=>{
            state.inSession = true
        },

        logout:state=>{
            state.inSession = false
        },

        setDatabase:(state,currentDatabase)=>{
            state.database = currentDatabase
        },

        setUser:(state,currentUser)=>{
            state.user = currentUser
        },

        setUserID:(state,userID)=>{
            state.user_id = userID
        },

        setProfilePicture:(state,profile_picture)=>{
            state.profile_picture = profile_picture
        },

        setLanguage:(state,language)=>{
            state.language = language
        },

        setCellar:(state,currentCellar)=>{
            state.cellar = currentCellar
        },

        setCellarID:(state,cellarID)=>{
            state.cellar_id = cellarID
        },

        setCellarLoaded:(state,cellarLoaded)=>{
            state.cellar_loaded = cellarLoaded
        },

        setNiches:(state,currentNiches)=>{
            state.niches = currentNiches
        },

        setNichesLoaded:(state,nichesLoaded)=>{
            state.niches_loaded = nichesLoaded
        },

        setNiche:(state,currentNiche)=>{
            state.niche = currentNiche
        },

        setNicheID:(state,nicheID)=>{
            state.niche_id = nicheID
        },

        setEntry:(state,currentEntry)=>{
            state.entry = currentEntry
        },

        setEntryID:(state,entryID)=>{
            state.entry_id = entryID
        },

        setPage:(state,page)=>{
            state.previous_page = state.current_page;
            state.current_page = page;
        },

        setContext:(state,context)=>{
            state.context = context;
        },

        setSearchState:(state,currentSearchState)=>{
            state.search_state = currentSearchState
        },

        setBottle:(state,bottle)=>{
            state.bottle = bottle
        },

        setBottleID:(state,bottle_id)=>{
            state.bottle_id = bottle_id
        },

        setWine:(state,wine)=>{
            state.wine = wine
        },

        setWineID:(state,wine_id)=>{
            state.wine_id = wine_id
        },

        setCWine:(state,c_wine)=>{
            state.c_wine = c_wine
        },

        setCWineID:(state,c_wine_id)=>{
            state.c_wine_id = c_wine_id
        },

        setWishlist:(state,wishlist)=>{
            state.wishlist = wishlist
        },

        setWishlistID:(state,wishlist_id)=>{
            state.wishlist_id = wishlist_id
        },
    },
})

/*
 * Persist ONLY the user ID.
 *
 * Do not persist the full user because it may contain
 * large base64 encoded profile images.
 */
store.subscribe((mutation, state) => {

    /*
     * LOGOUT OR RESET
     */
    if (
        mutation.type === 'logout' ||
        mutation.type === 'resetStore'
    ) {
        sessionStorage.removeItem(SESSION_KEY)
        return
    }

    /*
     * STORE ONLY A VALID LOGGED-IN USER ID
     */
    if (
        state.inSession === true &&
        state.user_id &&
        state.user_id !== 0
    ) {

        try {

            sessionStorage.setItem(
                SESSION_KEY,
                JSON.stringify({
                    user_id: state.user_id
                })
            )

        } catch (error) {

            console.log("store.subscribe: Could not save session - ", error)

        }
    }
})